<div class="dash-MainGrid">
	<!--School Select-->
	<div class="dash-MenuBarItem">
		<h5 class="dash-InnerItem control-label MinorHeading">School</h5>
		<div>
			<caass-schoolselector [Disabled]="IsLoading()" [ShowAll]="false"> </caass-schoolselector>
		</div>

		<h5 class="dash-InnerItem control-label MinorHeading" style="margin-top: 10px">Facility</h5>
		<div>
			<select [disabled]="IsLoading() == true" class="form-control" name="FacilityID" [(ngModel)]="FacilityID">
				<option value="" style="display: none"></option>
				<option *ngFor="let o of lstFacility" [ngValue]="o.FacilityID">[{{ o.FacilityCD }}] - {{ o.FacilityName }}</option>
			</select>
		</div>

		<button [disabled]="IsLoading() == true" class="btn btn-primary TopMargin" (click)="onRefresh()">Refresh</button>
	</div>

	<!--Components-->
	<div class="dashboard-grid">
		<div class="dash-Item" *ngIf="LoadingPreference == false && FacilityID != undefined">
			<caass-todays-visitor-stats [FacilityID]="FacilityID"> </caass-todays-visitor-stats>
		</div>

		<div class="dash-Item" *ngIf="LoadingPreference == false && FacilityID != undefined">
			<caass-facility-stats-ytd [FacilityID]="FacilityID" [FacilityStatPanel]="FacilityStatPanel"> </caass-facility-stats-ytd>
		</div>

		<div class="dash-Item" *ngIf="LoadingPreference == false && FacilityID != undefined">
			<caass-visitor-denied [FacilityID]="FacilityID"> </caass-visitor-denied>
		</div>

		<div class="dash-Item" *ngIf="LoadingPreference == false && FacilityID != undefined">
			<caass-district-stats-ytd [DistrictStatPanel]="DistrictStatPanel"> </caass-district-stats-ytd>
		</div>

		<div class="dash-Item" *ngIf="LoadingPreference == false && FacilityID != undefined">
			<caass-visitor-graph #Panel1 [FacilityID]="FacilityID" [GraphPanel]="GraphPanel1"> </caass-visitor-graph>
		</div>

		<div class="dash-Item" *ngIf="LoadingPreference == false && FacilityID != undefined">
			<caass-visitor-graph #Panel2 [FacilityID]="FacilityID" [GraphPanel]="GraphPanel2"> </caass-visitor-graph>
		</div>
	</div>
</div>
